import API from './api';

// Records one visit per browser session (not per page view/route change) —
// sessionStorage clears the "already tracked" flag when the tab/browser
// closes, localStorage keeps a stable visitorId across sessions so the
// admin dashboard can distinguish unique visitors from repeat visits.
const VISITOR_ID_KEY = 'goshala_visitor_id';
const SESSION_FLAG_KEY = 'goshala_visit_tracked';

const getVisitorId = () => {
  let id = localStorage.getItem(VISITOR_ID_KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(VISITOR_ID_KEY, id);
  }
  return id;
};

const isLocalDev = ['localhost', '127.0.0.1'].includes(window.location.hostname);

export default function trackVisit() {
  // Don't track admins browsing their own dashboard, and don't track local
  // development — the backend here points at the same production database,
  // so a `npm start` on a dev machine would otherwise show up as a real visit.
  if (window.location.pathname.startsWith('/admin')) return;
  if (isLocalDev) return;
  if (sessionStorage.getItem(SESSION_FLAG_KEY)) return;
  sessionStorage.setItem(SESSION_FLAG_KEY, '1');

  API.post('/visits/track', {
    visitorId: getVisitorId(),
    referrer: document.referrer || '',
    entryPath: window.location.pathname,
    language: navigator.language || '',
  }).catch(() => {}); // tracking is best-effort, never surface a failure to the visitor
}
